import {
  Sheet,
  SheetContent,
  SheetBody,
  SheetHeader,
  SheetTitle,
} from "@repo/ui/components/Base/Sheet";
import { TeamMemberForm } from "./TeamMemberForm";
import { useMemo } from "react";
import { useGetTeam } from "@/hooks/queryHooks/teamHooks";
interface EditTeamMemberSheetProps {
  open: boolean;
  setOpen: (arg1: boolean) => void;
  userId: string;
  teamId: string;
  tenantId: string;
}
export const EditTeamMemberSheet = ({
  open,
  setOpen,
  userId,
  teamId,
  tenantId,
}: EditTeamMemberSheetProps) => {
  const { data: teamData } = useGetTeam(tenantId, teamId);
  const teamMember = useMemo(
    () => teamData?.teamMembers.find((tm) => tm.userId === userId),
    [teamData, userId]
  );

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="overflow-y-scroll">
        <SheetHeader>
          {teamMember && (
            <div>
              <SheetTitle>Edit Team</SheetTitle>
              <SheetBody>
                <TeamMemberForm
                  initialValues={teamMember}
                  teamId={teamId}
                  tenantId={tenantId}
                  handleCancel={() => setOpen(false)}
                  handleComplete={() => setOpen(false)}
                  submitButtonText="Save"
                />
              </SheetBody>
            </div>
          )}
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
